import { OtherPagesService } from './../Services/otherPages.service';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-other-pages',
    templateUrl: './other_pages.component.html',
    styleUrls: ['./other_pages.component.scss']
})
export class OtherPageComponent {
    route: string;
    public dataPage: any;
    public headerDisabled: boolean;
    public footerDisabled: boolean;
    constructor(
        private _router: Router,
        private otherPageService: OtherPagesService,
        @Inject(DOCUMENT) private document: any
    ) {
        this.route = this._router.url.slice(1);
        this.getDataPage();
        // console.log(';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;Hola desde constructor');
    }
    getDataPage() {
        this.otherPageService.getDataOtherPage(this.route).subscribe(
            result => {
                if (result.html === undefined || result.html === '') {
                    this._router.navigate(['home']);
                } else {
                    this.dataPage = result;
                    console.log('Datos de pagina: ', result);
                    this.initComponentsStatus();
                }
            },
            error => {
                const errorMessage = <any>error;
                console.warn(errorMessage);
                this._router.navigate(['home']);
            }
        );
    }
    initComponentsStatus() {
        if (this.dataPage.options.elementsInactives) {
            this.headerDisabled = (this.dataPage.options.elementsInactives.find(e => e === 'Header') !== undefined) ? true : false;
            this.footerDisabled = (this.dataPage.options.elementsInactives.find(e => e === 'Footer') !== undefined) ? true : false;
        }
    }
}
